export const TASK_LABEL = "Task Name";
export const TASK_NAME = "taskName";
export const DUEDATE_LABEL = "Due Date";
export const DUEDATE_NAME = "dueDateName";
export const TYPE_LABEL = "Type";
export const TYPE_NAME = "typeName";
export const STATUS_LABEL = "Status";
export const STATUS_NAME = "statusName";
